module.exports = "/packs/media/images/icons/EliminateSubs_1-38abb6f70d699652330df78c1d4cf36e.png";